/** The study link could not be used: missing or malformed parameters, or the study is closed. */

import { PROLIFIC_HOME_URL } from '@overcooked/shared'

export function EntryError({ title, detail }: { title: string; detail: string }) {
  return (
    <section className="gate" data-testid="study-entry-error">
      <h1>{title}</h1>
      <p className="hint">{detail}</p>
      <p className="hint">
        <a href={PROLIFIC_HOME_URL}>Back to Prolific</a>
      </p>
    </section>
  )
}
